// removed by extract-text-webpack-plugin
module.exports = {"classGalleryModal":"GalleryModal-classGalleryModal-4760e15d","classGalleryModalLeft":"GalleryModal-classGalleryModalLeft-e965ee09","classCaption":"GalleryModal-classCaption-a3d28db3","classGalleryModalRight":"GalleryModal-classGalleryModalRight-f1acff54","classGalleryH2":"GalleryModal-classGalleryH2-c7308952","classGalleryAdvert":"GalleryModal-classGalleryAdvert-298119e1"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/GalleryModal.scss
// module id = 913
// module chunks = 0